import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const Amex = ({ size, className, id }) => {
  let ratio = size / 100;

  let width = size,
    height = 63 * ratio;

  let _attributes = {
    width: width || 100,
    height: height || 63,
    viewBox: "0 0 100 63"
  };

  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(className);
  }

  return (
    <svg {..._attributes}>
      <g transform="translate(-921 -619)">
        <rect width="100" height="63" transform="translate(921 619)" fill="none" />
        <g transform="translate(949.17 630.268)">
          <path d="M592,294h41.759v41.759H592V294Z" transform="translate(-592 -294)" fill="#016fd0" fillRule="evenodd" />
          <path d="M626.942,397.726V391.17h6.942l.745.971.769-.971h25.2v6.1a2.909,2.909,0,0,1-1.421.452H645.222l-.84-1.034v1.034H641.63v-1.764a2.309,2.309,0,0,1-1.189.246h-.936v1.518h-4.166l-.744-.992-.755.992Z" transform="translate(-618.836 -368.627)" fill="#fff" fillRule="evenodd" />
          <path d="M592,357.789l1.565-3.649h2.707l.888,2.044v-2.044h3.365l.529,1.478.513-1.478h15.106v.743a3.259,3.259,0,0,1,2.1-.743l4.9.017.873,2.017v-2.035h2.816l.775,1.159v-1.159h2.842V360.7h-2.842l-.743-1.162V360.7h-4.138l-.416-1.034H621.73l-.409,1.034h-2.806a2.774,2.774,0,0,1-1.841-.728v.728h-4.231l-.84-1.034V360.7H595.872l-.416-1.034h-1.109l-.413,1.034H592v-2.907Z" transform="translate(-592 -340.187)" fill="#fff" fillRule="evenodd" />
          <path d="M594.146,357.623l-2.111,4.909h1.375l.39-.983h2.265l.387.983h1.4l-2.109-4.909Zm.781,1.143.69,1.718h-1.383l.692-1.718Z" transform="translate(-592.027 -342.863)" fill="#016fd0" fillRule="evenodd" />
          <path d="M617.754,362.529V357.62l1.953.007,1.136,3.165,1.109-3.172h1.938v4.909h-1.227v-3.617l-1.3,3.617h-1.076l-1.3-3.617v3.617Z" transform="translate(-611.779 -342.86)" fill="#016fd0" fillRule="evenodd" />
          <path d="M647.824,362.529V357.62h4v1.1h-2.765v.84h2.7v1.033h-2.7v.872h2.765v1.066Z" transform="translate(-634.873 -342.86)" fill="#016fd0" fillRule="evenodd" />
          <path d="M668.149,357.623v4.909h1.227v-1.744h.517l1.471,1.744h1.5l-1.615-1.809a1.5,1.5,0,0,0,1.346-1.508,1.588,1.588,0,0,0-1.716-1.593Zm1.227,1.1h1.4a.563.563,0,0,1,.581.517.555.555,0,0,1-.563.517h-1.421v-1.034Z" transform="translate(-650.483 -342.863)" fill="#016fd0" fillRule="evenodd" />
          <path d="M690.729,362.529h-1.253V357.62h1.253v4.909Z" transform="translate(-666.862 -342.86)" fill="#016fd0" fillRule="evenodd" />
          <path d="M699.826,362.529h-.271a2.163,2.163,0,0,1-2.1-2.434,2.249,2.249,0,0,1,2.439-2.474h1.356v1.163h-1.406a1.181,1.181,0,0,0-1.145,1.324,1.2,1.2,0,0,0,1.324,1.35h.323l-.517,1.072Z" transform="translate(-672.988 -342.861)" fill="#016fd0" fillRule="evenodd" />
          <path d="M712.206,357.623l-2.111,4.909h1.375l.389-.983h2.265l.388.983h1.405l-2.109-4.909Zm.781,1.143.69,1.718H712.3l.692-1.718Z" transform="translate(-682.698 -342.863)" fill="#016fd0" fillRule="evenodd" />
          <path d="M735.805,362.529V357.62h1.56l1.992,3.084V357.62h1.227v4.909h-1.51l-2.043-3.165v3.165Z" transform="translate(-702.443 -342.86)" fill="#016fd0" fillRule="evenodd" />
          <path d="M630.562,399.559v-4.909h4v1.1H631.8v.84h2.7v1.034h-2.7v.872h2.765v1.066Z" transform="translate(-621.616 -371.299)" fill="#016fd0" fillRule="evenodd" />
          <path d="M715.146,399.559v-4.909h4v1.1h-2.765v.84h2.687v1.034h-2.687v.872h2.765v1.066Z" transform="translate(-686.577 -371.299)" fill="#016fd0" fillRule="evenodd" />
          <path d="M648.34,399.559l1.95-2.424-2-2.485h1.546l1.189,1.536,1.193-1.536h1.486l-1.97,2.454,1.953,2.455h-1.546l-1.154-1.512-1.127,1.512Z" transform="translate(-635.234 -371.3)" fill="#016fd0" fillRule="evenodd" />
          <path d="M672.186,394.653v4.909h1.26v-1.55h1.292a1.7,1.7,0,0,0,1.922-1.708,1.616,1.616,0,0,0-1.762-1.651Zm1.26,1.11h1.36a.554.554,0,0,1,.606.565.566.566,0,0,1-.61.565h-1.356v-1.13Z" transform="translate(-653.583 -371.302)" fill="#016fd0" fillRule="evenodd" />
          <path d="M693.763,394.649v4.909h1.227v-1.744h.517l1.471,1.744h1.5l-1.615-1.809a1.5,1.5,0,0,0,1.346-1.508,1.588,1.588,0,0,0-1.716-1.592h-2.731Zm1.227,1.1h1.4a.563.563,0,0,1,.581.517.555.555,0,0,1-.563.517H694.99v-1.034Z" transform="translate(-670.155 -371.299)" fill="#016fd0" fillRule="evenodd" />
          <path d="M734.343,399.559v-1.066H736.8c.363,0,.521-.2.521-.412s-.157-.415-.521-.415h-1.11a1.372,1.372,0,0,1-1.5-1.47c0-.787.492-1.546,1.926-1.546h2.39l-.517,1.1h-2.067c-.4,0-.517.207-.517.405a.428.428,0,0,0,.452.428h1.162A1.347,1.347,0,0,1,738.559,398a1.472,1.472,0,0,1-1.6,1.562Z" transform="translate(-701.2 -371.3)" fill="#016fd0" fillRule="evenodd" />
          <path d="M753.759,399.559v-1.066h2.352c.364,0,.521-.2.521-.412s-.157-.415-.521-.415H755.1a1.372,1.372,0,0,1-1.5-1.47c0-.787.492-1.546,1.926-1.546h2.342l-.517,1.1h-2.02c-.4,0-.517.207-.517.405a.428.428,0,0,0,.452.428h1.059A1.347,1.347,0,0,1,757.871,398a1.472,1.472,0,0,1-1.6,1.562Z" transform="translate(-716.112 -371.3)" fill="#016fd0" fillRule="evenodd" />
        </g>
      </g>
    </svg>
  );
};

Amex.defaultProps = {
  size: 100,
  className: "",
  id: ""
};

Amex.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
